export default __webpack_public_path__ + "static/media/literacy_images.15129b40.png";